import { useAppSelector } from 'store/hooks';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { selectHasPollTemplates } from 'features/polls/pollsSlice';
import { selectHasQuizTemplates } from 'features/quizzes/quizzesSlice';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { selectIsBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';

export const usePollTemplates = () => {
  const { hasPermissions } = usePermissions();
  const pollsFeatureEnabled = useFeatureFlag('polls');

  const isBreakoutRoom = useAppSelector(selectIsBreakoutRoom);

  const canManagePolls = hasPermissions(PermissionTypes.managePolls);

  const canManageTemplates = hasPermissions(PermissionTypes.managePollTemplates);

  const hasPollTemplates = useAppSelector(selectHasPollTemplates);
  const hasQuizTemplates = useAppSelector(selectHasQuizTemplates);

  const templatesAvailable =
    !isBreakoutRoom && pollsFeatureEnabled && canManagePolls && canManageTemplates;

  return {
    templatesAvailable,
    canManageTemplates,
    hasPollTemplates,
    hasQuizTemplates,
  };
};
